import { render, staticRenderFns } from "./privacy-statement.vue?vue&type=template&id=6427f6a4&scoped=true&lang=pug&"
import script from "./privacy-statement.vue?vue&type=script&lang=js&"
export * from "./privacy-statement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6427f6a4",
  null
  
)

export default component.exports